import moment from 'moment';

// Pure helpers for the URL-controlled period filter on the /trial_points pages.
// URL contract: ?range=this_month|last_month|last_3_months|custom[&start_date&end_date]

export const RANGE_OPTIONS = [
  { value: 'this_month', label: 'This month' },
  { value: 'last_month', label: 'Last month' },
  { value: 'last_3_months', label: 'Last 3 months' },
  { value: 'custom', label: 'Custom dates' }
];

const VALID_RANGES = RANGE_OPTIONS.map((o) => o.value);
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

// readPeriodParams parses the query string; invalid range or custom-without-dates falls back to this_month.
export const readPeriodParams = (search) => {
  const params = new URLSearchParams(search);
  let range = params.get('range') || 'this_month';
  if (!VALID_RANGES.includes(range)) range = 'this_month';
  const customStart = DATE_RE.test(params.get('start_date') || '') ? params.get('start_date') : '';
  const customEnd = DATE_RE.test(params.get('end_date') || '') ? params.get('end_date') : '';
  if (range === 'custom' && (!customStart || !customEnd)) range = 'this_month';
  return { range, customStart, customEnd };
};

// resolvePeriod maps a range to inclusive YYYY-MM-DD dates. last_3_months = this month + the 2 before it.
export const resolvePeriod = (range, customStart, customEnd) => {
  if (range === 'last_month') {
    const start = moment().subtract(1, 'months').startOf('month');
    return {
      startDate: start.format('YYYY-MM-DD'),
      endDate: start.clone().endOf('month').format('YYYY-MM-DD')
    };
  }
  if (range === 'last_3_months') {
    return {
      startDate: moment().subtract(2, 'months').startOf('month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD')
    };
  }
  if (range === 'custom' && customStart && customEnd) {
    return { startDate: customStart, endDate: customEnd };
  }
  return {
    startDate: moment().startOf('month').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD')
  };
};

// buildPeriodSearch updates the query string for a period change; resets page, keeps other params.
export const buildPeriodSearch = (currentSearch, range, customStart, customEnd) => {
  const params = new URLSearchParams(currentSearch);
  params.set('range', range);
  if (range === 'custom') {
    if (customStart) params.set('start_date', customStart);
    if (customEnd) params.set('end_date', customEnd);
  } else {
    params.delete('start_date');
    params.delete('end_date');
  }
  params.delete('page');
  return `?${params.toString()}`;
};
